import styled from "styled-components";
import ClickableElement from "../../../../utils/ClickableElement";

interface IListItemProps {
  alternateColor?: boolean;
}

export const ListItem = styled.li<IListItemProps>(
  ({ theme, alternateColor }) => `
  background: ${alternateColor ? theme.colors.lightblue : theme.colors.lightgrey3};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: ${theme.fontSizes.regular};
  justify-content: space-between;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  min-width: 60rem;
`
);

export const ListItemContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-left: 0.5rem;
  width: 100%;
  height: 5rem;
  padding-left: 1rem;
  svg {
    margin-right: 0.5rem;
  }
`;

export const ListItemButtonsContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const ListItemTitle = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  font-size: ${({ theme }) => theme.fontSizes.regular};
`;

export const SubList = styled.div`
  margin-left: 2.5rem;
`;

export const SublistButton = styled(ClickableElement)`
  align-items: center;
  background: inherit;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 5rem;
  justify-content: space-around;
  width: auto;

  svg {
    margin: 0;
  }
`;

export const AddUnitButton = styled.button`
  border: none;
  background: inherit;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
`;

export const dragSourceStyle = {
  alignItems: "center",
  cursor: "move",
  display: "flex",
  height: "3rem",
  justifyContent: "space-around",
  width: "5rem",
};
